<ng-container *transloco="let _t">

<h4 class="indicator-title">{{indicator.name}}</h4>
<div class="row">

<!-- Description -->
<div *ngIf="indicator.description!=undefined"
	class="col-12 fineHeight indic-description" [id]="'description-'+indicator.id">

</div>

<!-- 7 cols pour  description + infos techniques + grav/evol -->
<div class="col-7">
  <div class="desc-infos">
	<p class="desc">{{indicator.description}}</p>
	<div class="row frame infos">
		<!-- applicable ou non -->
		<div class="col-2 fineHeight text-center" *ngIf="indicator.answer!=undefined">
			<strong *ngIf="!indicator.answer.active">{{ _t('audit-questionnary-indicator-strong-0') }}</strong>
			<strong *ngIf="indicator.answer.active">{{ _t('audit-questionnary-indicator-strong-1') }}</strong>
			<br>
			<mat-slide-toggle
				color="primary"
				[(ngModel)]="indicator.answer.active"
				(change)="setChanged(indicator)"
				[title]="diagnostic.questionnary.disableunrevelant ? _t('audit-questionnary-indicator-title-2bis') : _t('audit-questionnary-indicator-title-2')"
        [disabled]="diagnostic.questionnary.disableunrevelant">
			</mat-slide-toggle>
		</div>

		<!-- Pondération -->
		<div class="col-5 weighting fineHeight" *ngIf="gd.connectedUser.isAuditor && isAnswerActive()">
			<label><strong>{{ _t('audit-questionnary-indicator-strong-2') }} </strong></label><br>
			<input type="range" min="1" max="10" step="1"
				name="weighting" [(ngModel)]="indicator.answer.revelent"
				(change)="setChanged(indicator);" />
			<span [matBadge]="indicator.answer.revelent" matBadgeOverlap="true" color="warn"></span>
		</div>

		<!-- couleur et niveau de tranche de risque-->
		<div class="col-5 fineHeight" *ngIf="gd.connectedUser.isAuditor && isAnswerActive()">
			<label><strong>{{ _t('audit-questionnary-indicator-strong-3') }} </strong></label>
			<br>
			<span [ngStyle]="{'background-color': indicator.answer.slice.color, 'width': '20px'}">
				&nbsp; &nbsp; &nbsp;
			</span>
			<span> &nbsp; {{ _t(indicator.answer.slice.name) }}
			</span>

			<!--calcul du score-->
			<br><span>{{indicator.answer.gravityScore}} x {{indicator.answer.evolution}} = {{indicator.answer.score}}</span>
		</div>
	</div>
  </div>
	<p>&nbsp;</p>

	<!-- gravité + évolution -->
	<div class="row frame picheight">

		<!-- GRAVITÉ -->
		<div class="col-6 gravity" *ngIf="isAnswerActive()">

			<!-- Mode additif / soustractif -->
			<div *ngIf=" indicator.multichoicegravity!=0 else unichoicegravity">
				<h5><span>{{ _t('audit-questionnary-indicator-span-7') }}</span>
					<button class="rightTitleButton"
							[title]="_t('audit-questionnary-indicator-title-3')"
							color="primary"
							(click)="indicator.answer.resetGravity(); setChanged(indicator)">
						<mat-icon color="disabled">indeterminate_check_box</mat-icon>
					</button>
				</h5>
				<p><mat-icon color="warn">warning</mat-icon> {{ _t('audit-questionnary-indicator-p-1') }}</p>

				<ol class="gravities">
				<li *ngFor="let gravity of indicator.gravities; let g=index; ">
					<mat-checkbox class="in-questionnary" *ngIf="gravity.label!=''"
						[value]="gravity.weigth" color="primary"
						[(ngModel)]="indicator.answer.gravityArray[g]"
						(change)="setChanged(indicator)" >
						{{gravity.label}}
					</mat-checkbox>
				</li>
				</ol>
			</div>

			<!-- Mode exclusif -->
			<ng-template #unichoicegravity>
				<h5><span>{{ _t('audit-questionnary-indicator-span-5') }}</span>
					<button class="rightTitleButton"
							[title]="_t('audit-questionnary-indicator-title-3')"
							color="primary"
							(click)="indicator.answer.resetGravity(); setChanged(indicator)">
						<mat-icon color="disabled">indeterminate_check_box</mat-icon>
					</button>
				</h5>

				<mat-radio-group class="gravities"
					[(ngModel)]="indicator.answer.gravityScore"
					(change)="setChanged(indicator)" >
				<ol class="gravities">
				<li *ngFor="let gravity of indicator.gravities; let g=index; ">
					<mat-radio-button  *ngIf="gravity.label!=''"
						[value]="gravity.weight" color="primary"
						[checked]="indicator.answer.gravityScore==gravity.weight"
						>
						{{gravity.label}}
					</mat-radio-button>
				</li>
				</ol>
				</mat-radio-group>

			</ng-template>
		</div>

		<!-- EVOLUTION -->
		<div class="col-6 evolution" *ngIf="gd.connectedUser.isAuditor && isAnswerActive()">
			<h5><span>{{ _t('audit-questionnary-indicator-span-6') }}</span>
				<button class="rightTitleButton"
						[title]="_t('audit-questionnary-indicator-title-3')"
						color="primary"
						(click)="indicator.answer.resetEvolution(); setChanged(indicator)">
					<mat-icon color="disabled">indeterminate_check_box</mat-icon>
				</button>
			</h5>

			<mat-radio-group class="evolution"
				[(ngModel)]="indicator.answer.evolution"
				(change)="setChanged(indicator)" >
			<ol class="gravities">
			<li *ngFor="let evolution of indicator.evolutions; let e=index; ">
				<mat-radio-button [value]="e+1" color="primary"
				[checked]="indicator.answer.evolution==(e+1)">
					{{evolution}}<br/>
				</mat-radio-button>
			</li>
			</ol>
			</mat-radio-group>
		</div>
	</div> <!-- /gravité + évolution -->
</div> <!-- /infos techniques + description + grav/evol -->



<div class="col-5"> <!--text + pics -->

	<!-- freetext -->
	<div class="frame comment">
		<h5>{{ _t('audit-questionnary-indicator-h5-0') }}</h5>
		<mat-form-field>
			<textarea matInput color="basic" name="freetext"
			[(ngModel)]="indicator.answer.freetext"
			(change)="setChanged()">
			</textarea>
		</mat-form-field>
	</div>

	<p>&nbsp;</p>

	<!-- freephoto -->
	<div *ngIf="isAnswerActive()" class="frame picheight">
		<h5>{{ _t('audit-questionnary-indicator-h5-1') }}</h5>
		<div class="pics" [id]="'pics-'+indicator.id">

			<cmat-picture *ngFor="let photo of indicator.answer.freephoto; let i=index"
				[src]="photo"
				[alt]="(photo=='') ? 'Nouvelle photo' : 'Photo '+(i+1)"
				[uploadable]="true"
				(changeTriggered)="indicator.answer.addPhoto($event, i); pushToRight(indicator.id); setChanged(indicator)"
				[path]="'b'+diagnostic.building.id+'-d'+diagnostic.id+'-i'+indicator.id"
				[filename]="'p'+i"
				[freeAfterChange]="photo == ''"
				[ngStyle]="{ 'left': (i*33)+'%' }"></cmat-picture>

		</div>
	</div>
</div>

</div><!-- /row -->

</ng-container>
